import React from 'react';
import { Chip } from '@material-ui/core';

export const renderCell = (column, row) => {
  const value = row[column.field];

  // Custom renderer
  if (typeof column.render === 'function') {
    return column.render(value, row);
  }

  switch (column.type) {
    case 'boolean':
      return <Chip size="small" color="primary" label={value ? 'Yes' : 'No'} />;

    default:
      return value ?? '';
  }
};
